import { allCampaignsSelector } from 'redux/selectors/campaign'

import CountryBlockedError from 'components/common/country_blocked'
import EmptyHub from 'components/pages/hub/empty_hub'
import NonEmptyHub from 'components/pages/hub/non_empty_hub'

export default function(store, history) {
  return {
    getComponent(nextState, callback) {
      const state = store.getState()
      if (state.current_user.moneypools_blocked) {
        return callback(null, CountryBlockedError)
      } else {
        const campaigns = allCampaignsSelector(store.getState())
        if (campaigns.length === 0) {
          return callback(null, EmptyHub)
        }
        return callback(null, NonEmptyHub)
      }
    },
  }
}
